module.exports = __webpack_public_path__ + "img/image155.c1fdbba1.jpg";